import { render, staticRenderFns } from "./ClassInformation.vue?vue&type=template&id=9332e5e6&"
import script from "./ClassInformation.vue?vue&type=script&lang=ts&"
export * from "./ClassInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9332e5e6')) {
      api.createRecord('9332e5e6', component.options)
    } else {
      api.reload('9332e5e6', component.options)
    }
    module.hot.accept("./ClassInformation.vue?vue&type=template&id=9332e5e6&", function () {
      api.rerender('9332e5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classes/ClassInformation.vue"
export default component.exports